import { AppConfig } from 'application/configuration'
import { Root } from 'application/Root'
import { GolfTheme, importCorvetteTheme } from 'application/theme'
import { logger } from 'lib/logger'
import ReactDOM from 'react-dom'

export { Root as ReactComponent } from 'application/Root'

type AppLaunchOptions = {
  container: HTMLElement | null
  theme?: GolfTheme
  config: AppConfig
}

export interface Launcher {
  /**
   * Запускает виджет
   * @param options
   */
  render: (options: AppLaunchOptions) => void
}

export const launch = async ({ container, config, theme }: AppLaunchOptions) => {
  globalThis.__SSR__ = false

  if (!container) throw Error('KodixEcom: no container provided')

  // Если передана тема Golf то не загружаем тему корвет
  const corvetteTheme = theme ? undefined : await importCorvetteTheme(config.projectName)

  logger.log('[App/GolfTheme]', theme)
  logger.log('[App/CorvetteTheme]', corvetteTheme)
  logger.log(`[App/Launch]: ${config.stages.map((stage) => stage.id).join(', ')}`, config)

  ReactDOM.render(<Root golfTheme={theme} corvetteTheme={corvetteTheme} config={config} />, container)
}
